import React from 'react'
import styled from 'styled-components'

const ForwardedRefButton = React.forwardRef(Button)

/**
 * @type {typeof Button}
 */
export const LinkButton = styled(ForwardedRefButton)`
  font-family: inherit;
  color: var(--ss-primary-color);
  background: transparent;
  border: none;
  user-select: none;
  outline: none;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? '0.4' : '1')};

  &:hover {
    color: var(--ss-primary-color-hover);
  }
`

/**
 *
 * @param {React.ButtonHTMLAttributes<HTMLButtonElement>} props
 */
function Button({ className, onClick, disabled, ...props }, ref) {
  const handleClick = disabled ? undefined : onClick
  return <button ref={ref} className={className} onClick={handleClick} {...props} />
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/elements/LinkButton/index.js